import{ useReducer, useMemo } from 'react';

type Params = {
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  page: number;
  limit: number;
  search?: string;
  stockAvailability:string;
  addedBy:string | undefined;
  merchantId: string;
  storeId?: string;
};

const getInitialParams = (): Params => {
  const merchantId =
    JSON.parse(localStorage.getItem('userData') || '{}')?.userId || '';

  return {
    page: 1,
    limit: 10,
    sortOrder: 'asc',
    sortBy: 'createdAt',
    search: undefined,
    stockAvailability: 'All',
    addedBy: undefined,
    merchantId,
    storeId: undefined,
  };
};

type Action =
  | { type: 'SET_SEARCH'; payload: string | undefined }
  | { type: 'SET_PAGE'; payload: number }
  | { type: 'SET_LIMIT'; payload: number }
  | { type: 'SET_SORT'; payload: { sortBy: string; sortOrder: 'asc' | 'desc' } }
  | { type: 'SET_STORE_ID'; payload: string | undefined }
  | { type: 'RESET' };

function reducer(state: Params, action: Action): Params {
  switch (action.type) {
    case 'SET_SEARCH':
      return { ...state, search: action.payload, page: 1 };
    case 'SET_PAGE':
      return state.page === action.payload ? state : { ...state, page: action.payload };
    case 'SET_LIMIT':
      return { ...state, limit: action.payload, page: 1 };
    case 'SET_SORT':
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
        page: 1,
      };
    case 'SET_STORE_ID':
      return {
        ...state,
        storeId: action.payload,
        page: 1,
      };
    case 'RESET':
      return getInitialParams();
    default:
      return state;
  }
}

export function useItemManagementParams() {
  const [params, dispatch] = useReducer(reducer, getInitialParams());

  const stableParams = useMemo(() => params, [
    params.sortBy,
    params.sortOrder,
    params.page,
    params.limit,
    params.search,
    params.merchantId,
    params.storeId,
  ]);

  return { params: stableParams, dispatch };
}
